import React from 'react';
import { Sidebar, useSidebarState } from 'react-admin';
import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const MySidebar = (props) => {
    const [open, setOpen] = useSidebarState();

    return (
        <Sidebar {...props}>
            <Box sx={{
                display: 'flex',
                justifyContent: open ? 'flex-end' : 'center',
                padding: '10px 0',
                borderBottom: '1px solid rgba(255, 255, 255, 0.12)'
            }}>
                <IconButton onClick={() => setOpen(!open)} color="inherit">
                    <MenuIcon />
                </IconButton>
            </Box>
            {props.children}
        </Sidebar>
    );
};

export default MySidebar;
